module.exports = __webpack_public_path__ + "img/logo.d211b9b4.webp";